import { Modal } from '@/components';
import { Button } from '@/components/Button';
import { R } from '@/Resources.resx';

export type InlineAlertProps = {
    onClose: () => void;
    errorMessage: string;
};

export const InlineAlert = ({ onClose, errorMessage }: InlineAlertProps) => {
    return (
        <div>
            <h2>{R.Error}</h2>
            <main className="py-6">
                <p className="my-0">{errorMessage}</p>
            </main>
            <footer className="text-right">
                <Button variant="primary" onClick={() => onClose()}>
                    {R.Ok}
                </Button>
            </footer>
        </div>
    );
};
